export default __webpack_public_path__ + "static/media/grafema_severe_08.fe454350.jpg";